module.exports = __webpack_public_path__ + "static/media/Ban on commitment to support certain activities.280aec19.png";